import React, { useMemo } from "react";
import { Image, View } from "react-native";
import style from "../Styles/main";

export default () => {
  const image = useMemo(() => require("../assets/Images/loading.gif"), []);

  return (
    <View style={style.mainView}>
      <Image source={image} style={style.loading} />
    </View>
  );
};
